import React, { useState, useEffect } from 'react';
import { Users, ShoppingBag, Zap, ArrowRight, X, CheckCircle } from 'lucide-react';

const OnboardingGuide = ({ onClose }) => {
  const [step, setStep] = useState(0);
  const steps = [
    { icon: Users, title: 'Add a Trading Partner', desc: 'Connect your first retailer like Walmart, Target, or Amazon. We have pre-loaded compliance configs for 8 major retailers — just select and go.', color: '#10b981' },
    { icon: ShoppingBag, title: 'Connect Your Shopify Store', desc: 'Go to Settings → Organization and enter your Shopify app credentials. We automatically sync orders, create draft orders from POs, and generate invoices.', color: '#3b82f6' },
    { icon: Zap, title: 'You\'re Automated', desc: 'That\'s it. When a retailer sends a purchase order, we create the Shopify order. When you fulfill it, we send the ASN and invoice back. All automatic, 24/7.', color: '#f59e0b' }
  ];
  const s = steps[step];
  const Icon = s.icon;

  return (
    <div style={{ position:'fixed', inset:0, background:'rgba(0,0,0,0.7)', display:'flex', alignItems:'center', justifyContent:'center', zIndex:9999, padding:'20px' }}>
      <div style={{ background:'#1e293b', borderRadius:'20px', maxWidth:'500px', width:'100%', overflow:'hidden', border:'1px solid #334155' }}>
        <div style={{ background:`linear-gradient(135deg, ${s.color}, ${s.color}dd)`, padding:'40px', textAlign:'center', position:'relative' }}>
          <button onClick={onClose} style={{ position:'absolute', top:'12px', right:'12px', background:'rgba(255,255,255,0.2)', border:'none', color:'white', borderRadius:'50%', width:'32px', height:'32px', cursor:'pointer', display:'flex', alignItems:'center', justifyContent:'center' }}><X size={16}/></button>
          <Icon size={48} style={{ color:'white', marginBottom:'16px' }}/>
          <h2 style={{ color:'white', fontSize:'24px', fontWeight:'800', margin:0 }}>{s.title}</h2>
        </div>
        <div style={{ padding:'32px' }}>
          <p style={{ color:'#94a3b8', fontSize:'15px', lineHeight:'1.7', marginBottom:'32px' }}>{s.desc}</p>
          <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center' }}>
            <div style={{ display:'flex', gap:'8px' }}>
              {steps.map((_, i) => (
                <div key={i} style={{ width: i===step?'24px':'8px', height:'8px', borderRadius:'4px', background: i===step?s.color:'#334155', transition:'all 0.3s' }}/>
              ))}
            </div>
            {step < 2 ? (
              <button onClick={() => setStep(step+1)} style={{ background:s.color, color:'white', border:'none', padding:'12px 24px', borderRadius:'10px', fontSize:'14px', fontWeight:'700', cursor:'pointer', display:'flex', alignItems:'center', gap:'6px' }}>
                Next <ArrowRight size={16}/>
              </button>
            ) : (
              <button onClick={onClose} style={{ background:s.color, color:'white', border:'none', padding:'12px 24px', borderRadius:'10px', fontSize:'14px', fontWeight:'700', cursor:'pointer', display:'flex', alignItems:'center', gap:'6px' }}>
                Get Started <CheckCircle size={16}/>
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OnboardingGuide;
